// Static data for the EDUtainment Pros / Young Mogul Program site

export const IMAGES = {
    heroBg: "https://static.prod-images.emergentagent.com/jobs/16d90490-d803-4986-a7fe-c9568c94ebb5/images/c82b352126958458da5ba0857e419adedc8b6bf81833baacbff56a99c9c55968.png",
    waveform:
        "https://static.prod-images.emergentagent.com/jobs/16d90490-d803-4986-a7fe-c9568c94ebb5/images/7084dba50c9efcfaf3e51a1438176900fa34caec5139ed80e3b5fde5bceaace4.png",
    goldTexture:
        "https://static.prod-images.emergentagent.com/jobs/16d90490-d803-4986-a7fe-c9568c94ebb5/images/80ab529561c50a646061caee9e09b28eec7a6020423e4b0e688fe427e4c27b4b.png",
    studio1:
        "https://images.pexels.com/photos/23858479/pexels-photo-23858479.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    studio2:
        "https://images.pexels.com/photos/14072290/pexels-photo-14072290.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stage: "/assets/signature.png",
    signature:
        "/assets/signature.png",
};

export const PHASES = [
    {
        week: "WK 1-2",
        title: "Brand Architecture & Digital Foundation",
        desc: "Identity, voice, visual systems. Build the brand pillars and digital presence every Young Mogul carries.",
        deliverables: [
            "Personal Brand Kit",
            "Mission Statement",
            "Canva Certification",
            "Digital Portfolio Setup",
            "Coaching with Marketing Pro",
        ],
    },
    {
        week: "WK 3-4",
        title: "Media Production &\nClient Relations",
        desc: "Commercial shoots, photography, client onboarding workflows, and how to pitch your work.",
        deliverables: [
            "Client Onboarding Doc",
            "Commercial Project",
            "Pitch Deck",
            "Coaching with Film Industry Pro",
            "YM3 Team Badge",
        ],
    },
    {
        week: "WK 5-6",
        title: "Studio Engineering &\nLyrical Storytelling",
        desc: "Studio sessions, audio engineering, music production, and lyric writing.",
        deliverables: [
            "Original Songs",
            "Commercial Recording Experience",
            "Studio Reel",
            "Coaching with Music Industry Pro",
        ],
    },
    {
        week: "WK 7-8",
        title: "Marketing Synergy & Rehearsals",
        desc: "Marketing campaign rollouts, financial empowerment, and stage-ready rehearsals.",
        deliverables: [
            "Targeted Marketing Campaign",
            "Promotions Knowledge Base",
            "Financial Literacy Workshops with Golden 1 Credit Union",
            "Performance Workshops",
        ],
    },
    {
        week: "WK 9",
        title: "Grand Finale Showcase",
        desc: "Live showcase event. Performances, brand reveals, Young Mogul Awards and certifications.",
        deliverables: [
            "Live Performance",
            "Industry Network",
            "Young Mogul Graduate Certification",
            "Young Mogul Awards",
        ],
    },
];

export const MENTORS = [
    // ============ MENTORS (top row) ============
    {
        initials: "MA",
        name: "Miss Anjel",
        role: "Vice President",
        group: "mentor",
        bio: "Serves as a vital Project Manager for the Young Mogul Program, bringing seven years of dedicated leadership to the initiative. With experience in international Child Development, she infuses a global perspective into youth empowerment, designing structured environments where the next generation of innovators and leaders can thrive.",
        photo: "/assets/anjel.png",
    },
    {
        initials: "OP",
        name: "Mister O.P.",
        role: "Visual Director",
        group: "mentor",
        bio: "A Young Mogul alumnus and YMP Director with four years of mentorship and leadership experience in the program. A global videographer who has worked on major film productions and international music video shoots, he brings high-level industry experience directly to the next generation of creatives.",
        photo: "/assets/op.png",
    },
    {
        initials: "MP",
        name: "Mister Prop",
        role: "Music Director",
        group: "mentor",
        bio: "With two decades of music production excellence working alongside icons like E-40 and Scarface, Prop combines world-class industry insight with a passion for mentorship. As an expert AI Guru, he brings cutting-edge tech literacy to his five years of experience directing and empowering youth. Deeply invested in community growth, he has directly shaped the Young Mogul Program, serving a year as a YMP Mentor and a year as a YMP Director to cultivate the leaders of tomorrow.",
        photo: "/assets/prop.png",
    },
    {
        initials: "HV",
        name: "Miss Hayla",
        role: "Mentor",
        group: "mentor",
        bio: "UC Riverside graduate, recording artist (Hayla V), and youth mentor. Since 2020, she has shared stages with icons like Rakim, Mya, and LaRussell, while dedicating the last four years to empowering students from 4th grade to college freshmen through programs like Sisters of Nia and Sankofa Peer Mentorship.",
        photo: "/assets/hayla.png",
    },
    {
        initials: "ML",
        name: "Miss Lizzy",
        role: "Mentor",
        group: "mentor",
        bio: "UC Riverside graduate with experience in Child Development. Rapper, singer, and songwriter with music projects alongside LaRussell and Nef the Pharaoh — bringing artistry and lived experience straight to the next generation.",
        photo: "/assets/lizzy.png",
    },

    // ============ PROS (bottom row) ============
    {
        initials: "HY",
        name: "Hayón",
        role: "CEO / Founder EDUtainment Pros",
        group: "pro",
        bio: "Mickelle \"Hayón\" Hellon is a Sacramento-based global recording artist who serves as the Executive Director of OccupyLove Worldwide and the CEO and founder of EDUtainment Pros. He launched EDUtainment Pros in 2017 following a surge in local teenage homicides and the tragic loss of a mentee to gun violence, aiming to inspire, cultivate, and empower young creative professionals. As CEO, Hayón guides the organization's flagship Young Mogul Program, which provides underserved youth with tangible career resources, lifelong mentorship, and access to a robust network of industry experts. Under his leadership, the initiative has successfully scaled to serve over ten schools across six Greater Sacramento school districts, blending local educational impact with his extensive background in global humanitarian work.",
        photo: "/assets/hayon.png",
    },
    {
        initials: "RD",
        name: "Roshaun Davis",
        role: "Executive Director\nFounder CLTRE",
        group: "pro",
        bio: "Roshaun Davis is a multifaceted community development leader and the founder of Unseen Heroes, a creative agency that has delivered high-quality event logistics and management services for over a decade. As the Executive Director of CLTRE, he guides a visionary organization dedicated to reshaping Sacramento's cultural landscape by the year 2040 through building, creating, and preserving culture. Under his strategic leadership, the initiative implements wide-ranging projects that promote youth skill development, community engagement, and advocacy for social equity. His transformative impact has earned him widespread peer respect and prestigious accolades, including the 40 Under 40 Award, Sacramento Top 100 People, and the Top 25 Black Changemakers in Sacramento. Roshaun's commitment to the Young Mogul Program is to help bridge young creative professionals to career opportunities in the creative sector.",
        photo: "/assets/roshaun.jpg",
    },
    {
        initials: "NL",
        name: "Nick Leisure",
        role: "CEO Leisure Films\nHollywood Film Director",
        group: "pro",
        bio: "Nick is a big budget film Director, Producer, and Screenwriter. As CEO of Leisure Films, a prominent feature film production, servicing, and distribution company located in California, he has established offices situated in Sacramento and Los Angeles. With over two decades in operation, they have established themselves as one of the foremost production companies not only in California but across the United States and internationally. Nick has shown a huge presence for our Young Moguls aspiring to build a career in the film industry. Beyond coaching as a guest speaker in our Young Mogul school sites, he has also mentored Young Moguls on movie sets in California and Mexico.",
        photo: "/assets/nick.png",
    },
    {
        initials: "CS",
        name: "Cedric Singleton",
        role: "CEO / Founder\nBlack Market Records",
        group: "pro",
        bio: "Global record label owner with over 40 years of experience in the music industry. Cedric has grown his company from a local Sacramento-based label to an international powerhouse with offices and artists in international markets like Cuba, Kenya, Uganda, Ghana, the Dominican Republic, Jamaica, and more. Cedric has committed to the Young Mogul Program by offering studio space in his elite facilities in Sacramento, mentoring and speaking with Young Moguls at our YMP school sites, and linking aspiring producers, artists, and executives with his roster of international pro artists, producers, and executives.",
        photo: "/assets/cedric.jpg",
    },
    {
        initials: "MR",
        name: "Magical Rock Band",
        role: "International\nBand of Siblings",
        group: "pro",
        bio: "The Magical Rock Band is an independent, Hip-Hop Rock inspired group from Sacramento, California, composed of four talented siblings: MRB Ty, MRB Jr, MRB Mike, and MRB Lyna. Driven by core pillars like peace, love, and family, they blend diverse musical genres to create inspirational music that encourages youth worldwide to value themselves. Expanding their international footprint, the band recently completed a mini tour through the Eastern Horn of Africa, where they captured widespread media attention featured on the hit television shows 10over10 and Teen Republik. Whether headlining massive festivals for over 70,000 attendees or directly feeding young babies in the Mukuru Kwa Ruben slums, they consistently use their rising platform to drive profound humanitarian impact. The Magical Rock Band were the first Young Moguls. Their commitment to the Young Mogul Program has been providing performance opportunities at major events and community gatherings, repping the program in international markets, participating in the production and guest-appearing in Young Mogul music videos, and also teaching in the Young Mogul classrooms as year-long instructors.",
        photo: "/assets/magical-rock.jpg",
        imgClass: "object-top",
    },
];

export const TESTIMONIALS = [
    {
        name: "Jaylen, 16",
        cohort: "Cohort 3",
        quote: "Before YMP I was making beats in my closet. Now I have a brand, a portfolio, and a paying client. This program is real.",
    },
    {
        name: "Aaliyah, 17",
        cohort: "Cohort 4",
        quote: "I came in shy. I left the finale headlining a stage in front of 2,000 people. Young Mogul gave me my voice.",
    },
    {
        name: "Marcus, 15",
        cohort: "Cohort 5",
        quote: "The mentors don't just teach you music. They show you how to run a business and stay true to who you are.",
    },
    {
        name: "Destiny, 18",
        cohort: "Cohort 2 — Now Alumni Mentor",
        quote: "I'm in college studying media production because of YMP. Now I'm back, mentoring the next class of moguls.",
    },
];

export const PARTNERS = [
    "Elk Grove USD",
    "San Juan USD",
    "Sacramento City USD",
    "Twin Rivers USD",
    "Elverta USD",
    "Folsom Cordova USD",
    "City of San Francisco",
    "City of Sacramento",
    "India Basin Waterfront Park",
    "Mack Road Community Partnership",
    "Greater Sacramento Urban League",
    "Sacramento Chinese Community Service Center",
    "Oak Park Community Center",
    "Guild Theater",
];

export const STATS_FALLBACK = {
    young_moguls: 400,
    students_reached: 3600,
    school_districts: 7,
    live_audience: 25000,
    certifications: 280,
    community_events: 45,
};

export const CONTACT = {
    phone: "(916) 400-9537",
    email: "EDUtainmentpros@gmail.com",
    youtube: "https://www.youtube.com/@EDUtainmentPros",
    instagram: "https://www.instagram.com/edutainmentpros",
    tiktok: "https://www.tiktok.com/@edutainmentpros",
};
